import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';
import { LOAD_SETTINGS, CHANGE_SETTINGS, DELETE_SETTINGS } from './constants';

import {
  loadSettingsError,
  loadSettingsSuccess,
  changeSettingsError,
  changeSettingsSuccess,
  deleteSettingsSuccess,
  deleteSettingsError,
} from './actions';

import { selectSettingsDomain, selectSettingsData } from './selectors';

import { Button, notification, Divider, Space } from 'antd';

export function* loadSettings() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));

    // we get the campaigns linked to the settings
    const settingsList = yield requestWrapper('GET', `students/list`, '', currentUser?.token);

    if (!settingsList) {
      yield put(loadSettingsSuccess(false));
    } else {
      yield put(loadSettingsSuccess(settingsList));
    }
  } catch (error) {
    yield put(loadSettingsError(error));
  }
}

export function* changeSettings(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    //const settingsData = yield select(selectSettingsData());
    const { settingsData } = action;

    let changedSettings = false,
      isNew = !settingsData.hasOwnProperty('_id');

    if (settingsData._id === undefined) {
      changedSettings = yield requestWrapper(
        'POST',
        'settings/new/',
        settingsData,
      );
      notification.success({ message: 'Created' });
    } else {
      changedSettings = yield requestWrapper(
        'PATCH',
        'settings/',
        settingsData,
      );
      notification.success({ message: 'Updated' });
    }

    if (!changedSettings) {
      yield put(changeSettingsSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        //history.push({ pathname: `/settings/`+settingsData._id });
      }
      yield put(changeSettingsSuccess(changedSettings));
    }
  } catch (error) {
    yield put(changeSettingsError(error));
  }
}

export function* deleteSettings(action) {
  try {
    // we retrieve the token from the local storage
    const token = localStorage.getItem('token');
    const { id } = action;

    const deleteSettings = yield requestWrapper(
      'PATCH',
      `settings/remove`,
      {
        _id: id,
        active: false,
      },
      token,
    );

    if (deleteSettings) {
      yield put(deleteSettingsSuccess());
    }
  } catch (error) {
    yield put(deleteSettingsError(error));
  }
}

export default function* settingsSaga() {
  yield takeLatest(LOAD_SETTINGS, loadSettings);
  yield takeLatest(CHANGE_SETTINGS, changeSettings);
  yield takeLatest(DELETE_SETTINGS, deleteSettings);
}
